import React from 'react';
import AnnualAwardSummaryCard from './components/AnnualAwardSummaryIndex.jsx';

const AnnualAwardSummary = () => <AnnualAwardSummaryCard />;

export default AnnualAwardSummary;
